import React from 'react'

interface BrailleLogoProps {
  className?: string
}

const BrailleLogo: React.FC<BrailleLogoProps> = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 310 310"
      className={className}
    >
      <ellipse fill="#302f2f" cx="210.1" cy="156.3" rx="35.4" ry="34.4" />
      <ellipse fill="#302f2f" cx="210.1" cy="38.6" rx="35.4" ry="34.4" />
      <ellipse fill="#302f2f" cx="99.9" cy="156.3" rx="35.4" ry="34.4" />
      <ellipse fill="#302f2f" cx="99.9" cy="273.9" rx="35.4" ry="34.4" />
    </svg>
  )
}

export default BrailleLogo
